/*
 * @Description:
 * @Date: 2025-12-09 15:00:50
 */
import { WEBVIEW_TASK_URL, INVESTMENT_URL } from '@constants/webview';
import { ProjectType } from '@cTypes/project';
import Qs from 'qs';

const WEBVIEW_COMMON_VIEW_PARAMS = {
  platform: 'mgmt',
  preview: '1'
};
const WEBVIEW_TASK_PARAMS = {
  from: 'record'
};
/**
 * @description: 模板预览任务
 */
export const useTempWebviewTaskUrl: (payload: {
  tempId: number; // 任务模板id
  projectType: ProjectType;
  informationId?: number; // 资讯id，例如数字问卷需要
}) => string = ({ tempId, projectType, informationId }) => {
  const webviewQuery = {
    tempId,
    projectType,
    ...(informationId && { informationId }),
    ...WEBVIEW_COMMON_VIEW_PARAMS,
    ...WEBVIEW_TASK_PARAMS
  };
  return `${WEBVIEW_TASK_URL[projectType].detail}?${Qs.stringify(
    webviewQuery
  )}`;
};
/**
 * @description: 项目预览任务
 */
export const useProjectWebviewTaskUrl: (payload: {
  projectId: number;
  projectType: ProjectType;
  informationId?: number;
}) => string = ({ projectId, projectType, informationId }) => {
  const webviewQuery = {
    projectId,
    projectType,
    ...(informationId && { informationId }),
    ...WEBVIEW_COMMON_VIEW_PARAMS,
    ...WEBVIEW_TASK_PARAMS
  };
  return `${WEBVIEW_TASK_URL[projectType].home}?${Qs.stringify(webviewQuery)}`;
};
// 本地postMessage预览
export const usePreviewWebviewTaskUrl = (
  projectType: ProjectType,
  extra?: {
    informationId?: number;
  }
) => {
  const webviewQuery = {
    projectType,
    usePostMessage: 1,
    ...WEBVIEW_COMMON_VIEW_PARAMS,
    ...(extra?.informationId && { informationId: extra.informationId })
  };
  return `${WEBVIEW_TASK_URL[projectType].detail}?${Qs.stringify(
    webviewQuery
  )}`;
};
// 企业招商
export const usePreviewWebviewInvestmentUrl = configId => {
  const webviewQuery = {
    configId,
    ...WEBVIEW_COMMON_VIEW_PARAMS
  };
  return `${INVESTMENT_URL}?${Qs.stringify(webviewQuery)}`;
};
// 预览分享任务
export const useShareWebviewTaskUrl = ({
  projectId,
  projectType,
  informationId,
  taskId,
  showType,
  targetType
}) => {
  const webviewQuery = {
    projectId,
    projectType,
    taskId,
    ...(showType && projectType === 17 && { showType }),
    ...(targetType && projectType === 17 && { targetType }),
    ...(informationId && projectType === 21 && { informationId }),
    ...WEBVIEW_COMMON_VIEW_PARAMS,
    ...WEBVIEW_TASK_PARAMS
  };
  return `${WEBVIEW_TASK_URL[projectType].share}?${Qs.stringify(webviewQuery)}`;
};
